import { TrendingUp, BarChart2, FileText, Microscope, BookMarked } from "@/components/icons";
import type { CategoryMeta } from "./types";

export const POSTS_PER_PAGE = 6;

export const categoryMeta: Record<string, CategoryMeta> = {
  Report: { color: "#60A5FA", icon: <FileText size={12} /> },
  Analysis: { color: "#FBBF24", icon: <TrendingUp size={12} /> },
  Study: { color: "#22D3EE", icon: <Microscope size={12} /> },
  Benchmark: { color: "#34D399", icon: <BarChart2 size={12} /> },
  Survey: { color: "#A78BFA", icon: <BookMarked size={12} /> },
};

export function getCategoryColor(cat: string): string {
  return categoryMeta[cat]?.color ?? "#FFFFFF";
}
